import { ConfigurationAssayResponse } from '@/modules/configurationModule/detail/assays/configuration-assays/services/configuration-assay/configuration-assay.dto'

export interface ConfigurationAssaysModalState {
    assay: Partial<ConfigurationAssayResponse>
}
export const initialConfigurationAssaysModalState =
    (): ConfigurationAssaysModalState => ({
        assay: {
            active: true,
            isNaa: false
        }
    })
